import {Injectable, OnDestroy} from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot, Router,
} from '@angular/router';
import {catchError, distinct, from, map, Observable, of, Subscription, tap} from 'rxjs';
import {BusinessUnitService} from "../modules/business-units/services";
import {IBusinessUnit} from "../modules/business-units/models";
import {ToastrService} from "ngx-toastr";
import {UtilService} from "../modules/shared/services";
import { DataService } from '../services/data/data.service';

@Injectable({
  providedIn: 'root'
})
export class SelectedBusinessUnitResolver implements Resolve<IBusinessUnit | null> {

  constructor(
    private dataService: DataService,
    private businessUnitService: BusinessUnitService,
    private util: UtilService,
  ) {
    
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IBusinessUnit | null> {
    var businessUnitId = route.paramMap.get('id');
    // this.dataService.adminSelectedBusinessUnitId = businessUnitId;

    if (!businessUnitId) {
      this.util.sendUserToErrorPage("Selected Business Unit Error!  Please contact support.");
      return of(null);
    }

    return this.businessUnitService.getBusinessUnit(businessUnitId).pipe(
      tap((bu: IBusinessUnit) => {
        console.log("Fetched business unit in resolver: ", bu);
        this.dataService.setSelectedAdminBusinessUnit(bu);
      }),
      catchError(err => {
        this.util.sendUserToErrorPage("Selected Business Unit Error!  Please contact support.");
        return of(null);
      })
    );
  }

  // private fetchAndDispatchEditingBusinessUnit(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
  //   return new Promise<boolean>((resolve, reject) => {
  //     let editingBusinessUnitId = route.paramMap.get('id');
  //     if (this.util.isAdmin()) {
  //       if (!!editingBusinessUnitId) {
  //         this.businessUnitService.getBusinessUnit(editingBusinessUnitId).subscribe({
  //           next: (bu: IBusinessUnit) => {
  //             this.store.dispatch(updateEditingBusinessUnit({businessUnit: bu}));
  //             resolve(true);
  //           }, error: err => {
  //             resolve(true);
  //             this.router.navigate(['/' + this.config.selected_business_unit.slug + '/business-units']).then(() => {
  //               this.toastr.error("Access denied!", $localize`:@@companyName:Rondeivu`);
  //             });
  //           }
  //         });
  //       }
  //     } else {
  //       resolve(true);
  //       this.router.navigate(['/' + this.config.selected_business_unit.slug]).then(() => {
  //         this.toastr.error("Access denied!", $localize`:@@companyName:Rondeivu`);
  //       });
  //     }
  //   });
  // }
}
